<button mat-button [routerLink]="['/temperature']"><fa-icon [icon]="faThemometerHalf"></fa-icon> Ute: {{ currentTemperature }}°C</button>

